// import { __ } from '@wordpress/i18n';
import { store, getContext, getElement, getConfig } from '@wordpress/interactivity';

(function ($) {

    /**
     * Caleran attend des extensions non-standards sur Moment:
     * - `middleOfDay()` (non présent dans Moment "vanilla")
     * - `startOfMonth()` (utilisé par Caleran: `currentDate.clone().startOfMonth()`)
     *
     * Important: si on polyfill `middleOfDay()` avant de charger Caleran,
     * Caleran ne définira pas `startOfMonth()` (dans sa logique interne).
     * Donc on s'assure de polyfiller les DEUX.
     */
    function ensureMomentCaleranCompat() {
        if (typeof window.moment !== 'function') return;
        if (!window.moment.fn) return;

        // Moment est mutable: on reste cohérent avec ses méthodes chainables.
        if (typeof window.moment.fn.middleOfDay !== 'function') {
            window.moment.fn.middleOfDay = function () {
                return this.startOf('day').add(12, 'hours');
            };
        }

        // Méthode attendue par Caleran (non standard Moment.js)
        if (typeof window.moment.fn.startOfMonth !== 'function') {
            window.moment.fn.startOfMonth = function () {
                return this.middleOfDay().date(1);
            };
        }
    }

    // Si Moment est déjà présent (chargé par WP ou un autre plugin), on polyfill tout de suite.
    ensureMomentCaleranCompat();

    if (document.querySelectorAll('.gt-widgets-thelis-resa').length == 0) return;

    // Fonction pour charger dynamiquement un fichier JavaScript
    function loadScript(url, callback) {
        const script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.async = true;
        script.onload = callback;
        document.head.appendChild(script);
    }

    // Fonction pour charger dynamiquement un fichier CSS
    function loadStyle(url) {
        const link = document.createElement('link');
        link.href = url;
        link.type = 'text/css';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
    }

    // Charger js-cookie
    loadScript(gtFseThelisVars.pluginUrl + '/lib/jscookies/js.cookies.min.js');

    // Charger Moment.js
    loadScript(gtFseThelisVars.pluginUrl + '/lib/caleran/vendor/moment.min.js', function () {
        // Polyfill après chargement effectif de Moment, avant Caleran.
        ensureMomentCaleranCompat();
        // Après Moment.js, charger Caleran
        loadScript(gtFseThelisVars.pluginUrl + '/lib/caleran/js/caleran.min.js');
    });

        $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.gt-widgets-thelis-resa__toggle').addClass('open');
        } else {
            $('.gt-widgets-thelis-resa__toggle').removeClass('open');
        }
    });

    $(document).on('click', '.gt-widgets-thelis-resa__toggle', function () {
        $(this).parent().addClass('gt-widgets-thelis-resa--open');
    });

    $(document).on('click', '.gt-widgets-thelis-resa__hide', function () {
        $(this).parent().removeClass('gt-widgets-thelis-resa--open');
    });



    // Charger Caleran CSS
    loadStyle(gtFseThelisVars.pluginUrl + '/lib/caleran/css/caleran.min.css');

    $(document).on('click', '.gt-widgets-thelis-resa__form__entry--submit button', function (e) {
        e.preventDefault();

        // Au lieu de $(this).attr('data-useTwoDateInputs'), on prend l'attribut
        // sur le container qui porte "data-useTwoDateInputs":
        let $form = $(this).closest('.gt-widgets-thelis-resa__form');
        let $rangesContainer = $form.find('.gt-widgets-thelis-resa__form__entry--ranges');
        let useTwoDateInputs = $rangesContainer.attr('data-useTwoDateInputs') === "true";


        let begin, end;

        if (useTwoDateInputs) {
            // On sait maintenant que l’utilisateur a bien activé les deux inputs
            let arrivalDate  = $rangesContainer.find('input[name="arrival_date"]').val();
            let departureDate = $rangesContainer.find('input[name="departure_date"]').val();

            console.log('Arrival Date:', arrivalDate, 'Departure Date:', departureDate);

            if (!arrivalDate || !departureDate) {
                console.error('Arrival or departure date is undefined');
                return;
            }

            begin = formatDate(arrivalDate);
            end   = formatDate(departureDate);

            if (moment(end).isBefore(moment(begin))) {
                console.error('Departure date cannot be before arrival date');
                return;
            }
        } else {
            // Cas du single input
            let rangesInput = $rangesContainer.find('input').val();
            if (!rangesInput) {
                console.error('Date range input is undefined');
                return;
            }

            let ranges = rangesInput.split(' - ');
            console.log('Date Ranges:', ranges);

            if (ranges.length === 1) {
                begin = formatDate(ranges[0]);
                end   = begin;
            } else if (ranges.length === 2) {
                begin = formatDate(ranges[0]);
                end   = formatDate(ranges[1]);
            } else {
                console.error('Date range is not valid');
                return;
            }
        }

        // Récupération des autres champs
        let nb_pers = $form.find('.gt-widgets-thelis-resa__form__entry--personnes select').val() || 2;
        let type    = $form.find('.gt-widgets-thelis-resa__form__entry--type select').val();
        let camping = $form.find('input[name="camping"]').val();
        let lang    = $form.find('input[name="lang"]').val();

        let params = {
        begin:   begin,
        end:     end,
        nb_pers: nb_pers,
        type:    type,
        camping: camping,
        lang:    lang
        };

        let url = `https://thelisresa.webcamp.fr/list.php?${$.param(params)}`;
        window.open(url, '_blank');
    });

    $(window).on('load', function () {

        // Robustesse: Moment peut être (re)chargé / écrasé par WP ou un autre plugin après l'exécution initiale.
        // On re-garantit la présence de middleOfDay juste avant l'init Caleran.
        ensureMomentCaleranCompat();
        
        const gtOptions = store('gt/options');

        var opening = (gtOptions && gtOptions.state && gtOptions.state.opening_date) 
        ? moment(gtOptions.state.opening_date) 
        : moment();
        var closing = (gtOptions && gtOptions.state && gtOptions.state.closing_date) 
                ? moment(gtOptions.state.closing_date) 
                : null;

        let arrival = Cookies.get('gt-arrival') ? moment(Cookies.get('gt-arrival')) : (moment() > opening ? moment() : opening);
        let departure = Cookies.get('gt-departure') ? moment(Cookies.get('gt-departure')) : moment(arrival).add(7, 'days');


        $('.gt-widgets-thelis-resa__form__entry--ranges').each(function () {
            ensureMomentCaleranCompat();

            let useTwoDateInputs = $(this).attr('data-useTwoDateInputs') === "true";

            if (useTwoDateInputs) {
                let startDate, endDate;
                let startInstance, endInstance;

                const fillInputs = function () {
                    if (startInstance && startDate) {
                        startInstance.$elem.val(startDate.format(startInstance.config.format));
                    }
                    if (endInstance && endDate) {
                        endInstance.$elem.val(endDate.format(endInstance.config.format));
                    }
                };

                // Initialiser la date d'arrivée à aujourd'hui
                $(this).find('input[name="arrival_date"]').caleran({
                    format: 'DD/MM/YYYY',
                    locale: 'fr',
                    showHeader: false,
                    showFooter: false,
                    startDate: arrival,
                    autoCloseOnSelect: true,
                    minDate: opening,
                    maxDate: closing,
                    calendarCount: 1,
                    cancelLabel: "Annuler",
                    applyLabel: "Appliquer",
                    oninit: function (instance) {
                        startInstance = instance;
                        if (instance.config.startDate) {
                            startDate = instance.config.startDate.clone();
                            Cookies.set('gt-arrival', startDate.format('YYYY-MM-DD'), { expires: inTwoHours() });
                        }
                    },
                    onfirstselect: function (instance, start) {
                        startDate = start.clone();
                        startInstance.globals.startSelected = false;
                        startInstance.hideDropdown();
                        endInstance.showDropdown();
                        endInstance.config.minDate = startDate.clone();
                        endInstance.config.startDate = startDate.clone();
                        endInstance.config.endDate = null;
                        endInstance.globals.startSelected = true;
                        endInstance.globals.endSelected = false;
                        endInstance.globals.firstValueSelected = true;
                        endInstance.setDisplayDate(start);
                        fillInputs();
                    }
                }).data('caleran');

                // Initialiser la date de départ à aujourd'hui + 7 jours
                $(this).find('input[name="departure_date"]').caleran({
                    format: 'DD/MM/YYYY',
                    locale: 'fr',
                    showHeader: false,
                    showFooter: false,
                    endDate: departure,
                    autoCloseOnSelect: true,
                    minDate: arrival,
                    maxDate: closing,
                    calendarCount: 1,
                    cancelLabel: "Annuler",
                    applyLabel: "Appliquer",
                    oninit: function (instance) {
                        endInstance = instance;
                        if (instance.config.endDate) {
                            endDate = instance.config.endDate.clone();
                            Cookies.set('gt-departure', endDate.format('YYYY-MM-DD'), { expires: inTwoHours() });
                        }
                    },
                    onafterselect: function (instance, start, end) {
                        startDate = start.clone();
                        endDate = end.clone();
                        Cookies.set('gt-departure', endDate.format('YYYY-MM-DD'), { expires: inTwoHours() });
                        $('input[name="departure_date"]').val(endDate.format('DD/MM/YYYY'));
                        startInstance.config.endDate = endDate.clone();
                        startInstance.globals.firstValueSelected = true;
                        fillInputs();
                        endInstance.globals.startSelected = true;
                        endInstance.globals.endSelected = false;
                    }
                }).data('caleran');
            } else {
                $(this).find('input').caleran({
                    format: 'DD/MM/YYYY',
                    locale: 'fr',
                    showFooter: false,
                    startDate: arrival,
                    endDate: departure,
                    autoCloseOnSelect: true,
                    minDate: moment(),
                    calendarCount: $(window).width() < 768 ? 1 : 2,
                    cancelLabel: "Annuler",
                    applyLabel: "Appliquer",
                    oninit: function (caleran) {
                        let arrival = moment(caleran.config.begin).format('YYYY-MM-DD');
                        Cookies.set('gt-arrival', arrival, { expires: inTwoHours() });
                        let departure = moment(caleran.config.end).format('YYYY-MM-DD');
                        Cookies.set('gt-departure', departure, { expires: inTwoHours() });
                    },
                    onafterselect: function (caleran, begin, end) {
                        let arrival = moment(begin).format('YYYY-MM-DD');
                        Cookies.set('gt-arrival', arrival, { expires: inTwoHours() });
                        let departure = moment(end).format('YYYY-MM-DD');
                        Cookies.set('gt-departure', departure, { expires: inTwoHours() });
                    }
                });
            }
        });
    });

    function inTwoHours() {
        let time = new Date();
        time.setHours(time.getHours() + 2);
        return time;
    }

    // Formatage de la date
    function formatDate(dateString) {
        if (!dateString) return '';
        let parts = dateString.split('/');
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }

})(jQuery);
